<template>
  <div class="carpageHome">
    <div v-if="shopDimensions.length || invalidItems.length" class="shop__car">
      <div class="shop-content">
        <div class="shop-has-goods">
          <SearchNav ref="searchNav" />
          <div class="nav-wrapper">
            <div class="page-header">
              <h1 class="page-title">
                购物车
              </h1>
            </div>
            <div class="list-header">
              <div class="choose-all">
                <el-checkbox :value="checkAllStoreValue" @change="checkAllStore">全选</el-checkbox>
              </div>
              <div class="goods-info">商品信息</div>
              <div class="goods-data">规格</div>
              <div class="goods-price">单价</div>
              <div class="buy-amount">购买数量</div>
              <div class="goods-balance">商品总额</div>
              <div class="goods-action">操作</div>
            </div>
          </div>
          <div class="shopping-carList">
            <div
              :key="`shopDimension_${index}`"
              v-for="(sItem, index) in shopDimensions"
              class="CartList"
              :class="checkShopMap[sItem.shopId] ? 'CartList-active' : ''"
            >
              <div class="CartList-headerLine">
                <div class="shopInfo">
                  <el-checkbox
                    :indeterminate=" sItemSelected(sItem) && !checkShopMap[sItem.shopId] ? true : false"
                    @change="checkboxAllClick(sItem.shopId)"
                    :value="checkShopMap[sItem.shopId]"
                  ></el-checkbox>
                  <img v-if="sItem.shopIcon && sItem.shopIcon != ''" :src="sItem.shopIcon" alt="" class="shop-logo" />
                  <img v-else :src="require('@/assets/img/shop-logo.png')" class="shop-logo" />
                  <span @click="linkToStore(sItem)" class="shopName pointer">{{ sItem.shopName }} {{sItem.merchantEntityName}}</span>
                </div>
                <div>
                  <span
                    class="CartList-headerLine-card"
                  >
                    <span class="left">
                      <span >
                        <span class="notice-tips" v-if="sItem.remainLackStartDelivery <= 0 && sItem.totalPrice !==0 ">满足配送;</span>
                        <span v-else class="text">
                          <span v-if="sItem.startDeliveryThreshold === sItem.remainLackStartDelivery">
                            满{{ price(sItem.startDeliveryThreshold) }}元起送；
                          </span>
                          <span v-else>还差{{ price(sItem.remainLackStartDelivery) }}元起送；</span>
                        </span>
                      </span>
                      <span >
                        <span class="notice-tips" v-if="sItem.remainLackFreeShipping <= 0 && sItem.totalPrice !==0">满足包邮</span>
                        <span v-else class="text">
                          <span v-if="sItem.freeShippingAmount === sItem.remainLackFreeShipping">
                            满{{ price(sItem.freeShippingAmount) }}元包邮
                          </span>
                          <span v-else>还差{{ price(sItem.remainLackFreeShipping) }}元包邮</span>
                        </span>
                      </span>
                    </span>
                    <span class="right" v-if="sItem.remainLackStartDelivery > 0">
                      <span @click="goShopAll(sItem.shopId)" class="add-on-text pointer">
                        去凑单
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <GoodsItem
                v-for="gItem in sItem.validItemList"
                :key="gItem.cartId"
                :isDisabled="isLoading"
                :gItem="gItem"
                :shop-id="sItem.shopId"
                @deleteItem="deleteItem"
                @updateItem="updateItem"
                @checkboxClick="checkboxClick"
              />
              <div class="CartList-account">
                <p class="account-total">
                  <span class="CartList-weight">x {{ amount(sItem) }}</span>
                  合计：
                  <span class="CartList-weight-bold">¥{{ price(sItem.totalPrice) }}</span>
                </p>
              </div>
            </div>
            <!-- 失效商品 -->
            <div class="invalidItems" v-if="invalidItems && invalidItems.length">
              <p class="invalidItems-title">
                <span class="left">失效商品 &nbsp;x{{ invalidItems.length }}&nbsp;</span>
                <span class="right pointer" @click="deleteAllInvalid">清空失效商品</span>
              </p>
              <div class="loss-efficacy">
                <div
                  class="CartList-drugList"
                  :class="iItem.checked ? 'CartList-drugList-active' : ''"
                  v-for="iItem in invalidItems"
                  :key="iItem.id"
                >
                  <el-checkbox disabled></el-checkbox>
                  <img
                    class="CartList-drugList-img"
                    v-if="iItem.itemThumbnail && iItem.itemThumbnail.includes('http')"
                    :src="iItem.itemThumbnail"
                    alt=""
                  />
                  <img class="CartList-drugList-img" v-else :src="require('@/assets/img/goods-empty.png')" />
                  <div class="CartList-drugList-detail">
                    <p class="name">{{ iItem.itemName }}</p>
                    <p class="company">{{ iItem.enterprise }}</p>
                    <p class="invalid-sign">{{ iItem.invalidType }}</p>
                  </div>
                  <span class="CartList-drugList-dose">{{ iItem.unit }}</span>
                  <div class="CartList-drugList-time">
                    <p class="price">¥{{ price(iItem.sellingPrice) }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Layout>
      </div>
      <div class="shop-footer">
        <div class="shop-footer-content">
          <div class="shop-footer-content__left">
            <el-checkbox :value="checkAllStoreValue" @change="checkAllStore">全选</el-checkbox>
            <span @click="deleteSelectd" class="del-goods">删除选中商品</span>
          </div>
          <div class="shop-footer-content__center">
            <p>
              已选商品 
              <span class="orange">x {{ totamAmount }}</span>
               合计：
              <span class="orange-amount">¥{{ price(totalItemPrice) }}</span>
            </p>
          </div>
          <div
            :class="['shop-footer-content__right', checkedAllList.length === 0 ? 'disabled' : '']"
            @click="preSubmitTotal"
          >
            下一步{{ checkedAllList.length ? `(${checkedAllList.length})` : '' }}
          </div>
        </div>
      </div>
      <AddOnDialog ref="addOnRef" :list="shopDimensions" />
    </div>
    <CartNonePage class="cart-page" v-else />
  </div>

</template>

<script>
import SearchNav from '@/components/SearchNav';
import GoodsItem from './component/GoodsItem.vue';
import CartNonePage from './component/CartNonePage';
import { priceFenToYuan, throttle } from '@/helpers/utils';
import { mapActions, mapState } from 'vuex';
import { cloneDeep, difference } from 'lodash';
import AddOnDialog from './component/AddOnDialog.vue';
import * as api from '@/services';
export default {
  components: {
    CartNonePage,
    SearchNav,
    AddOnDialog,
    GoodsItem
  },

  beforeDestroy() {
    this.$store.dispatch('layout/SET_FOOTER', true);
  },
  mounted() {
    Telescope.trackPage({
      trackId: 'zyb2bpc-page-gwcy-gwcymB2B'
    });
    this.$store.dispatch('layout/SET_FOOTER', false);
  },
  data() {
    return {
      isFirstLoaded: false,
      refreshing: false,
      shopDimensions: [],
      invalidItems: [],
      recommendItems: [],
      totalItemPrice: 0,
      showAddOn: false,
      isLoading: false,
      showCouponPop: false,
      expandStateShop: false,
      expandStatePlat: false,
      shopCoupon: [],
      copyShopCoupon: [],
      platCoupon: [],
      copyPlatCoupon: [],
      checkShopMap: {}, // 店铺是否全选
      allShopWithItem: [], // 当前有选中商品的店铺（坐最大10个限制）
      checkedAllList: [], // 所有选中的购物车列表
      allCartListInShop: {}, // 店铺纬度所有的购物车列表
      getCouponItem: {},
      CollapseArr: []
    };
  },
  computed: {
    ...mapState('cart', ['addSuccessCartIds', 'addCartFailList']),
    checkAllStoreValue() {
      let checkAll = true;
      if (!this.shopDimensions.length) return false;
      this.shopDimensions.map((item) => {
        item.validItemList.map((o) => {
          if (!o.selected) checkAll = false;
        });
      });
      return checkAll;
    },
    totamAmount() {
      let num = 0;
      this.shopDimensions.map((item) => {
        item.validItemList.map((o) => {
          if (o.selected) num += o.num;
        });
      });
      return num;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('order', ['setPreOrderInfo']),
    ...mapActions('cart', ['setSuccessCartIds', 'setCartFailList']),
    linkToStore(item) {
      this.$router.push({ path: `/store/${item.shopId}/homePage` });
    },
    amount(sItem) {
      let num = 0;
      sItem.validItemList.map((o) => {
        if (o.selected) num += o.num;
      });
      return num;
    },
    sItemSelected(sItem) {
      let flag = false;
      sItem.validItemList.map((o) => {
        if (o.selected) flag = true;
      });
      return flag;
    },
    price(val) {
      return priceFenToYuan(val);
    },
    goShopAll(shopId) {
      this.$router.push(`/store/${shopId}/goods`);
    },
    deleteAllInvalid() {
      if (!this.invalidItems.length) return;
      this.$confirm('确定清空失效商品？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        title: null,
        alignFooter: 'right',
        type: 'warning'
      })
        .then(() => {
          api.cart.deleteInvalidGoods().then(() => {
            // this.getTotalNum();
            this.fetchData(this.checkedAllList, false);
            this.$refs.searchNav.updateCartNum();
          });
        })
        .catch(() => {});
    },
    deleteSelectd() {
      if (!this.checkedAllList.length) {
        this.$alert('请至少选择一个商品', '提示', {
          confirmButtonText: '确定',
          cancelButtonClass: 'custom_confirm_button',
          confirmButtonClass: 'custom_confirm_button',
          alignFooter: 'right'
        });
      } else {
        this.deleteItem(this.checkedAllList);
      }
    },
    deleteAll() {
      let arr = [];
      for (var i in this.allCartListInShop) {
        arr = arr.concat(this.allCartListInShop[i]);
      }
      this.deleteItem(arr);
    },
    reset() {
      this.isLoading = false;
      this.shopDimensions = [];
      this.invalidItems = [];
      this.recommendItems = [];
    },
    async fetchData(list, checkAll) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      // 展示购物车数据
      try {
        const res = await api.cart.showCart({
          selectedCartIds: list,
          allSelected: checkAll
        });
        this.totalItemPrice = res.totalInfoDTO.totalItemPrice;
        this.shopDimensions = res.shopDimensions;
        this.invalidItems = res.invalidItems || [];
        this.isFirstLoaded = true;
        // 获取选中状态
        let checkShopMap = {};
        let checkedAllList = [];
        let allCartListInShop = {};
        let allShopWithItem = [];
        let CollapseArr = [];
        res.shopDimensions.map((item) => {
          checkShopMap[item.shopId] = true;
          CollapseArr.push(item.shopId);
          allCartListInShop[item.shopId] = [];
          item.validItemList.map((o) => {
            allCartListInShop[item.shopId].push(o.cartId);
            if (!o.selected) checkShopMap[item.shopId] = false;
            if (o.selected) {
              checkedAllList.push(o.cartId);
              allShopWithItem.push(item.shopId);
            }
          });
        });
        this.CollapseArr = CollapseArr;
        this.checkShopMap = checkShopMap;
        this.checkedAllList = checkedAllList;
        this.allCartListInShop = allCartListInShop;
        this.allShopWithItem = Array.from(new Set(allShopWithItem));
      } catch (error) {
        // this.totalItemPrice = 0;
        // this.shopDimensions = [];
        // this.invalidItems = [];
        this.isFirstLoaded = true;
      }
      this.isLoading = false;
      if (!this.shopDimensions.length) {
        this.getRecommend();
      }
      this.setSuccessCartIds([]);
      this.setCartFailList([]);
    },
    async getRecommend() {
      const res = await api.goods.getGoodsList({
        aggregateFlag: false,
        pageNo: 1,
        pageSize: 10,
        orderType: 2
      });
      this.recommendItems = res.data.itemBasicInfos || [];
    },
    init() {
      this.reset();
      // this.getTotalNum();
      if (this.addSuccessCartIds && this.addSuccessCartIds.length) {
        if (this.addCartFailList && this.addCartFailList.length) {
          this.$message.error('部分商品因失效/售罄/库存不足等原因，本次未全部添加');
        } else {
          this.$message.success('加购成功');
        }
        this.fetchData(this.addSuccessCartIds, false);
      } else {
        this.fetchData([], false);
      }
    },
    handlerItemDetailClick(item) {
      this.$router.push(`/detail/${item.itemCode}`);
    },
    deleteItem(cartIds) {
      const _this = this;
      this.$confirm('确定要删除这些商品吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        title: null,
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        alignFooter: 'right',
        type: 'warning'
      })
        .then(async () => {
          await api.cart.deleteCart({ cartIds });
          _this.checkedAllList = difference(_this.checkedAllList, cartIds);
          _this.fetchData(_this.checkedAllList, false);
          _this.$refs.searchNav.updateCartNum();
        })
        .catch(() => {});
    },
    updateItem() {
      this.fetchData(this.checkedAllList, false);
    },
    checkboxClick(cartId) {
      if (this.checkedAllList.indexOf(cartId) > -1) {
        const existIndex = this.checkedAllList.indexOf(cartId);
        if (existIndex > -1) {
          this.checkedAllList.splice(existIndex, 1);
        }
        this.fetchData(this.checkedAllList, false);
      } else {
        if (this.allShopWithItem.length >= 10) {
          this.$message.error('一次最多只能选择10家店铺的商品哦，请重新选择');
          return;
        }
        this.fetchData(this.checkedAllList.concat(cartId), false);
      }
    },
    async checkboxAllClick(shopId) {
      let allCartListInShop = this.allCartListInShop;
      let checkedAllList = this.checkedAllList;
      if (this.checkShopMap[shopId]) {
        // 取消选中
        allCartListInShop[shopId].map((item) => {
          const existIndex = this.checkedAllList.indexOf(item);
          if (existIndex > -1) {
            this.checkedAllList.splice(existIndex, 1);
          }
        });
        this.fetchData(this.checkedAllList, false);
      } else {
        if (this.allShopWithItem.length >= 10) {
          this.$message.error('一次最多只能选择10家店铺的商品哦，请重新选择');
          return;
        }
        // 选中
        this.fetchData(checkedAllList.concat(allCartListInShop[shopId]), false);
      }
    },
    async checkAllStore() {
      if (!this.shopDimensions.length) {
        return;
      }
      if (!this.checkAllStoreValue && this.shopDimensions.length > 10) {
        this.$message.error('一次最多只能选择10家店铺的商品哦，请重新选择');
        return;
      }
      this.fetchData([], !this.checkAllStoreValue);
    },
    getPreOrderParams() {
      const params = {};
      params.cartIds = this.checkedAllList;
      return params;
    },
    preSubmitTotal: throttle(async function () {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-gwcy-gwcymdjxybanB2B'
      });

      if (this.isLoading) {
        return;
      }
      if (this.checkedAllList.length === 0) {
        return;
      }
      this.isLoading = true;
      const param = this.getPreOrderParams();
      if (param.cartIds.length === 0) {
        this.isLoading = false;
        this.$alert('请至少选择一个商品', '提示', {
          confirmButtonText: '确定',
          cancelButtonClass: 'custom_confirm_button',
          confirmButtonClass: 'custom_confirm_button',
          alignFooter: 'right'
        });
        return;
      }
      if (param.cartIds.length > 99) {
        this.isLoading = false;
        this.$alert('最多只能选择99种商品', '提示', {
          confirmButtonText: '确定',
          cancelButtonClass: 'custom_confirm_button',
          confirmButtonClass: 'custom_confirm_button',
          alignFooter: 'right'
        });
        return;
      }
      const data = await api.personal.getReceiveAddr();
      if (data.receiverList?.length) {
        param.addressId = data.receiverList[0].addrId;
      }
      this.setPreOrderInfo({ validPlatformCoupons: [], invalidPlatformCoupons: [] });
      api.order
        .preOrder(param)
        .then((res) => {
          const copyPreOrderInfo = cloneDeep(res);
          copyPreOrderInfo.merchantItemInfos.map((item) => {
            // 默认选中订单内所有商品的“商品药检报告”
            item.itemList.forEach((v) => {
              v.drugReport = true;
              v.sellQualification = false;
            });
          });
          this.setPreOrderInfo(copyPreOrderInfo);
          window.localStorage.setItem('preOrderInfo', JSON.stringify(copyPreOrderInfo));
          this.setSuccessCartIds([]);
          this.setCartFailList([]);
          this.$router.push('/confirmOrder');
        })
        .catch((error) => {
          if (
            error.error.code === 'SHARE_ORDER-ORDER_NOT_ENOUGH_AMOUNT' ||
            error.error.code === 'SHARE_ORDER-TMS-UNREACH_MIN_DELIVERY_AMOUNT'
          ) {
            this.$refs.addOnRef.dialogVisible = true;
          } else {
            this.$alert(error.error.message, '提示', {
              confirmButtonText: '确定',
              cancelButtonClass: 'custom_confirm_button',
              confirmButtonClass: 'custom_confirm_button',
              alignFooter: 'right'
            });
          }
        });
      this.isLoading = false;
    }, 2000)
  }
};
</script>

<style lang="scss" scoped>
.shop__car {
  display: flex;
  flex-direction: column;
  height: inherit;

  .shop-content {
    flex: 1;
    overflow-y: scroll;
    .shop-has-goods {
      width: 1232px;
      margin: 0 auto;
    }
    .nav-wrapper {
      .page-header {
        display: flex;
        align-items: baseline;
        margin-bottom: 16px;
        .page-title {
          display: inline-block;
          font-size: 24px;
          font-weight: 500;
          color: #333333;
          margin-right: 16px;
        }
      }
      .list-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 44px;
        padding: 0 16px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        background: #eef6ff;
        margin-bottom: 24px;
        .goods-info {
          margin-left: 24px;
        }
        .goods-data {
          margin-left: 290px;
        }
        .goods-price {
          margin-left: 187px;
        }
        .buy-amount {
          margin-left: 56px;
        }
        .goods-balance {
          margin-left: 130px;
        }
        .goods-action {
          margin-left: 100px;
        }
      }
    }
    .shopping-carList {
      padding-bottom: 102px;
      ::v-deep .el-input-number {
        width: 112px;
        height: 32px;
        margin-left: 55px;
        .el-input--mini .el-input__inner {
          height: 32px;
          line-height: 32px;
          border-radius: 0;
        }
        .el-input-number__decrease,
        .el-input-number__increase {
          width: 32px;
          height: 30px;
          line-height: 30px;
          border-radius: 0;
        }
      }
      .invalidItems {
        margin-top: 24px;
        .invalidItems-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left {
            width: 294px;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 14px;
          }
          .right {
            width: 84px;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1e8dff;
            line-height: 14px;
          }
        }
      }
    }
    .CartList {
      border: 0.5px dashed #888;
      margin: 16px 0px;
      background: #fafafa;
      &-active {
        background: #eff7ff;
      }
      &-headerLine {
        height: 46px;
        line-height: 44px;
        border-bottom: 0.5px dashed #dfdfdf;
        padding: 0 16px;
        width: 100%;
        font-size: 14px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .shopInfo {
          display: flex;
          align-items: center;
        }
        .shop-logo {
          margin-left: 8px;
          width: 30px;
          height: 30px;
        }
        .shopName {
          margin-left: 8px;
        }
        &-card {
          width: 450px;
          height: 18px;
          font-size: 12px;
          padding: 0 94px 0 4px;
          // margin-right: 36px;
          display: inline-block;
          position: relative;
          font-weight: 400;
          color: #333333;
          line-height: 12px;
          text-align: right;
          .left {
            margin-right: 12px;
          }
          .right {
            margin-right: 12px;
            width: 36px;
            height: 12px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #d96900;
            line-height: 12px;
            .add-on-text {
              white-space: nowrap;
            }
          }
        }
        &-icon {
          padding: 2px 4px;
          background: #ff3737;
          font-size: 12px;
          color: #ffffff;
          margin: 0px 4px 0px 8px;
        }
        &-up {
          float: right;
          line-height: 44px;
          margin-right: 24px;
          font-size: 12px;
          color: #1e8dff;
        }
      }
      ::v-deep .el-collapse-item__content {
        padding-bottom: 0;
        background: #fafafa;
      }
      ::v-deep .el-collapse-item__header {
        background: #fafafa;
        position: relative;
        .el-collapse-item__arrow {
          position: absolute;
          right: 8px;
        }
        .el-icon-arrow-right:before {
          content: '\e790';
        }
      }
      &-drugList {
        font-size: 12px;
        display: flex;
        text-align: start;
        height: 113px;
        padding: 16px;
        border-bottom: 0.5px dashed #dfdfdf;
        ::v-deep .el-checkbox__input {
          vertical-align: top;
        }
        background: #fafafa;
        &-active {
          background: #eff7ff;
        }
        &-img {
          width: 80px;
          height: 80px;
          margin-left: 15px;
        }
        &-detail {
          margin-left: 16px;
          width: 294px;
          .name {
            font-size: 12px;
            vertical-align: top;
            color: #333333;
          }
          .company {
            font-size: 12px;
            color: #888888;
          }
          .sign {
            display: inline-block;
            padding: 0px 4px;
            background: #ff8200;
            font-size: 12px;
            color: #ffffff;
            margin-top: 2px;
          }
          .invalid-sign {
            display: inline-block;
            padding: 0px 4px;

            background: #888888;
            font-size: 12px;
            color: #ffffff;
            margin-top: 8px;
          }
        }
        &-dose {
          display: inline-block;
          width: 125px;
          font-size: 12px;
          color: #333333;
        }
        &-time {
          width: 118px;
          .price {
            font-size: 12px;
            color: #333333;
            text-align: right;
          }
          .time {
            font-size: 12px;
            color: #888888;
            margin-top: 4px;
          }
        }
        &-price {
          color: #d96900;
          font-size: 18px;
          width: 134px;
          text-align: right;
          vertical-align: top;
          font-weight: 500;
        }
        &-del {
          width: 170px;
          text-align: center;
          color: #888888;
          font-size: 12px;
        }
      }
      &-account {
        font-size: 14px;
        height: 56px;
        line-height: 56px;
        // background: #fafafa;
        width: 978px;
        text-align: right;
        .account-total {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }
      &-weight {
        font-size: 18px;
        color: #d96900;
      }
      &-weight-bold {
        font-size: 20px;
        color: #d96900;
        font-weight: bold;
      }
    }
    .loss-efficacy {
      border: 0.5px dashed #ababab;
      margin-top: 16px;
    }
  }
  .shop-footer {
    background: #fafafa;
    position: fixed;
    bottom: 0;
    z-index: 999;
    left: 0;
    width: 100%;
    &-content {
      display: flex;
      justify-content: space-between;
      width: 1232px;
      margin: 0 auto;
      padding-left: 16px;
      &__left {
        display: flex;
        align-items: center;
        .del-goods {
          font-size: 14px;
          font-weight: 400;
          color: #888888;
          line-height: 14px;
          margin: 0 8px;
          cursor: pointer;
        }
        .clear-all {
          font-size: 14px;
          font-weight: 400;
          color: #888888;
          line-height: 14px;
          cursor: pointer;
        }
      }
      &__center {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        font-size: 14px;
        padding-right: 46px;
        color: #333333;
        > p {
          height: 70px;
          padding-top: 18px;
        }
        .total-free {
          margin: 0 12px;
        }
        .orange {
          color: #d96900;
          font-size: 18px;
          vertical-align: bottom;
        }
        .orange-amount {
          color: #d96900;
          font-size: 24px;
          vertical-align: bottom;
        }
      }
      &__right {
        width: 166px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
        background: #1e8dff;
        border: 1px solid #1e8dff;
        &.disabled {
          opacity: 0.45;
        }
      }
    }
  }
}
.invalidItems {
  .CartList-drugList:last-child {
    border-bottom: none !important;
  }
}
</style>
